<template>
  <ul class="mill-list">
    <li v-for="mill, index in mills" :key="index">
      <div class="mill-toggle-content" @click="toggleContent(index)" :class="{active: expanded.indexOf(index) !== -1}">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </div>

      <div @click="handleClick(mill)" class="mill-name">
        <div class="mill-percentage">
          {{ mill.percentage }}%
          <i class="fa fa-check"></i>
        </div>
              
        <i class="mill-selected fa fa-map-marker" :class="{selected: selectedMills.indexOf(mill) !== -1}" aria-hidden="true"></i>
        {{index + 1}}.
        {{mill.name}}
      </div>

      <dl class="mill-content" :class="{active: expanded.indexOf(index) !== -1}">
        <dt>Plant Type:</dt>
        <dd v-text="mill.type"></dd>
        <dt>Coverage:</dt>
        <dd v-text="mill.coverage + ' Miles'"></dd>
        <dt>Counties:</dt>
        <dd v-text="mill.counties"></dd>
      </dl>

    </li>
  </ul>
</template>

<script>
export default {
  name: 'sidebarnav',
  props: [
    'mills'
  ],
  computed: {
    selectedMills() {
      return this.$store.getters.getSelectedMills
    },
  },
  methods: {
    handleClick(mill) {
      this.$emit('millClick', mill)
    },
    toggleContent(index) {
      if(this.expanded.indexOf(index) === -1) {
        this.expanded.push(index)
      } else {
        this.expanded = _.without(this.expanded, index)
      }
    }
  },
  created (){

  },
  mounted (){

  },
  data () {
    return {
      expanded: []
    }
  }
}
</script>

<style lang="scss">
@import '../scss/global';

.mill-list {
  background: $white;
  list-style: none;
  margin: 0 0 30px;
  padding: 0 10px;
  // border-top: 1px solid #E4E3DF;
  border-bottom: 1px solid #E4E3DF;

  .fa-map-marker {
    margin-right: 0.25rem;
  }

  li {
    border-bottom: 1px solid #E4E3DF;
    padding: 5px;

    &:last-child {
      border-bottom: none;
    }

    .mill-name {
      font-weight: 400;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .mill-percentage {
      float: right;
      color: $primary-color;
      margin-left: 5px;
    }

    .mill-toggle-content {
      float: right;
      color: #979797;
      margin-left: 1em;

      .fa {
        cursor: pointer;
        transition: transform $animation-speed;
      }
      &.active .fa {
        transform: rotate(180deg);
      }
    }

    .mill-content {
      display: none;
      font-size: 13px;
      margin: 5px 0 0;
      &:after {
        content: '';
        display: block;
        clear: both;
      }
      &.active {
        display: block;
      }
      dt {
        min-width: 75px;
        display: inline-block;
        font-weight: normal;
      }
      dd {
        display: inline;

        &:after { 
         content: "\A";
         white-space: pre; 
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// MillList.vue?9f66ce92